import React, { useState, useRef } from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPhone, faMapMarkerAlt, faGlobe, faUser, faBuilding } from '@fortawesome/free-solid-svg-icons';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons';
import './ContactSection.css';

const ContactSection = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const nameInputRef = useRef();
  const emailInputRef = useRef();
  const messageInputRef = useRef();
  const maxNameLength = 30; // establece la longitud máxima del nombre
  const [nameError, setNameError] = useState('');
// Función para actualizar la clase CSS de los campos de entrada
const updateInputClass = (inputRef, isValid) => {
  if (isValid) {
    inputRef.current.classList.remove('is-invalid');
  } else {
    inputRef.current.classList.add('is-invalid');
  }
}

const validateName = () => {
  let isValid = true;
  const maxNameLength = 30; // establece la longitud máxima del nombre
  const nameRegex = /^[a-zA-Z\s]+$/; // expresión regular para validar que el nombre solo contenga letras y espacios
  if (!name) {
    nameInputRef.current.setCustomValidity('Por favor ingresa tu nombre');
    isValid = false;
  } else if (name.trim().length < 2) {
    nameInputRef.current.setCustomValidity('El nombre debe tener al menos 2 caracteres válidos');
    isValid = false;
  } else if (name.length > maxNameLength) {
    nameInputRef.current.setCustomValidity(`El nombre no puede tener más de ${maxNameLength} caracteres`);
    isValid = false;
  } else if (!name.match(nameRegex)) {
    nameInputRef.current.setCustomValidity('El nombre solo puede contener letras y espacios');
    isValid = false;
  } else {
    nameInputRef.current.setCustomValidity('');
  }
  updateInputClass(nameInputRef, isValid);
}




const validateEmail = () => {
  let isValid = true;
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  if (!email) {
    emailInputRef.current.setCustomValidity('Por favor ingresa tu correo electrónico');
    isValid = false;
  } else if (!email.includes('@')) {
    emailInputRef.current.setCustomValidity('Falta el símbolo @ en tu correo electrónico');
    isValid = false;
  } else if (!email.match(emailRegex)) {
    emailInputRef.current.setCustomValidity('El formato de tu correo electrónico no es válido');
    isValid = false;
  } else {
    emailInputRef.current.setCustomValidity('');
  }
  updateInputClass(emailInputRef, isValid);
}

const validateMessage = () => {
  let isValid = true;
  if (!message) {
    messageInputRef.current.setCustomValidity('Por favor ingresa tu mensaje');
    isValid = false;
  } else if (message.split(/\s+/).filter(word => word.match(/[a-z0-9]/i)).length < 2) {
    messageInputRef.current.setCustomValidity('El mensaje debe tener al menos 2 palabras con caracteres válidos');
    isValid = false;
  } else {
    messageInputRef.current.setCustomValidity('');
  }
  updateInputClass(messageInputRef, isValid);
}

  const handleSubmit = (event) => {
    event.preventDefault();

    validateName();
    validateEmail();
    validateMessage();

    if (event.target.checkValidity()) {
      setIsSubmitting(true);

      const data = {
        "data": [{
          "nombre": name,
          "email": email,
          "mensaje": message
        }]
      };

      fetch('https://sheetdb.io/api/v1/u0whmt9x1si29', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      })
        .then(response => response.json())
        .then(data => {
          console.log('Success:', data);
          // Limpiar el formulario
          setName('');
          setEmail('');
          setMessage('');
          // Mostrar el mensaje de éxito
          setSuccessMessage('Gracias por comunicarte, te responderé en breve');
          // Ocultar el mensaje después de 3 segundos
          setTimeout(() => {
            setSuccessMessage('');
          }, 3000);
        })
        .finally(() => {
          setIsSubmitting(false);
        });
    }
  }

  return (
    <section id="contact">
      <Container>
        <h2 className="contact-title text-center">Contacto</h2>
        <Row>
          <Col md={6}>
            <div className="contact-info">
              <p><span><FontAwesomeIcon className="fa-icon" icon={faUser} /> Alex Franco</span></p>
              <p><span><FontAwesomeIcon className="fa-icon" icon={faBuilding} /> AlexDev</span></p>
              <p><span><FontAwesomeIcon className="fa-icon" icon={faEnvelope} /> alexleaderhere@gmail.com</span></p>
              <p><span><FontAwesomeIcon className="fa-icon" icon={faPhone} /> +54 9 3537-333120</span></p>
              <p><span><FontAwesomeIcon className="fa-icon" icon={faMapMarkerAlt} /> Bell Ville, Córdoba, Argentina</span></p>
              <p><span><FontAwesomeIcon className="fa-icon" icon={faGlobe} /> <a href="https://talking-alex.netlify.app" target="_blank" rel="noopener noreferrer">Sitio Web</a></span></p>
              <p><span><FontAwesomeIcon className="fa-icon" icon={faLinkedin} /> <a href="https://www.linkedin.com/in/alexfranco" target="_blank" rel="noopener noreferrer">Linkedin</a></span></p>
            </div>
          </Col>

          <Col md={6}>

            <div className="contact-form">
              
          <Form onSubmit={handleSubmit}>
          <Form.Group controlId="formName">
  <Form.Label className="form-label">Nombre</Form.Label>
  <Form.Control
    className="form-control"
    type="text"
    placeholder="Ingresa tu nombre"
    value={name}
    onChange={(event) => {
      setName(event.target.value);
      validateName();
    }}
    onBlur={(event) => {
      setName(event.target.value);
      validateName();
    }}
    onInput={(event) => {
      setName(event.target.value);
      validateName();
    }}
    onSelect={(event) => {
      setName(event.target.value);
      validateName();
    }}
    onKeyPress={(event) => {
      if (name.length >= maxNameLength) {
        event.preventDefault();
        nameInputRef.current.setCustomValidity(`El nombre no puede tener más de ${maxNameLength} caracteres`);
        updateInputClass(nameInputRef, false);
      } else {
        nameInputRef.current.setCustomValidity('');
        updateInputClass(nameInputRef, true);
      }
    }}
    required
    ref={nameInputRef}
  />
</Form.Group>




  
  <Form.Group controlId="formEmail">
    <Form.Label className="form-label">Correo electrónico</Form.Label>
    <Form.Control
      className="form-control"
      type="email"
      placeholder="Ingresa tu correo electrónico"
      value={email}
      onChange={(event) => {
        setEmail(event.target.value);
        validateEmail();
      }}
      onSelect={(event) => {
        setEmail(event.target.value);
        validateEmail();
      }}
      onBlur={(event) => {
        setEmail(event.target.value);
        validateEmail();
      }}
      onInput={(event) => {
        setEmail(event.target.value);
        validateEmail();
      }}
      onMouseUp={(event) => {
        setEmail(event.target.value);
        validateEmail();
      }}
      onKeyUp={(event) => {
        setEmail(event.target.value);
        validateEmail();
      }}
      required
      ref={emailInputRef}
    />
  </Form.Group>
  <Form.Group controlId="formMessage">
    <Form.Label className="form-label">Mensaje</Form.Label>
    <Form.Control
      className="form-control"
      as="textarea"
      rows={3}
      placeholder="Ingresa tu mensaje"
      value={message}
      onChange={(event) => {
        setMessage(event.target.value);
        validateMessage();
      }}
      onBlur={(event) => {
        setMessage(event.target.value);
        validateMessage();
      }}
      required
      ref={messageInputRef}
    />
  </Form.Group>
  <Button className="btn-enviar" variant="primary" type="submit" disabled={isSubmitting}>
    {isSubmitting ? 'Enviando...' : 'Enviar'}
  </Button>
</Form>


              {successMessage && (
                <div className="success-message">{successMessage}</div>
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default ContactSection;
